import { Paper, useComputedColorScheme } from "@mantine/core";

export default function SelectCard({ children, selected, ...props }) {
  const colorScheme = useComputedColorScheme();

  let bg = "";
  if (selected) bg = colorScheme == "light" ? "gray.2" : "dark.6";

  return (
    <Paper
      withBorder
      bg={bg}
      p="xs"
      style={{ cursor: "pointer", overflow: "hidden" }}
      {...props}
    >
      {children}
    </Paper>
  );
}
